export const SYSTEM_USER_ID = '000000000000000000000000';

const SYSTEM_USER_IDS = new Set([
  SYSTEM_USER_ID,
  '000000000000000000000001',
]);

type ActorObject = {
  id?: unknown;
  _id?: unknown;
  name?: unknown;
  email?: unknown;
};

function asText(value: unknown): string | undefined {
  if (typeof value === 'string' || typeof value === 'number') {
    const text = String(value).trim();
    return text || undefined;
  }
  return undefined;
}

export function formatSystemUser(value: unknown, emptyLabel = '—'): string {
  if (value === null || value === undefined) return emptyLabel;

  if (typeof value === 'string' || typeof value === 'number') {
    const actorId = asText(value);
    return actorId && SYSTEM_USER_IDS.has(actorId) ? 'Hệ thống' : actorId || emptyLabel;
  }

  if (typeof value === 'object') {
    const actor = value as ActorObject;
    const actorId = asText(actor.id) || asText(actor._id);
    if (actorId && SYSTEM_USER_IDS.has(actorId)) return 'Hệ thống';
    return asText(actor.name) || asText(actor.email) || actorId || emptyLabel;
  }

  return emptyLabel;
}
